<template>
    <div class="step5">
        <h1>Aanvraagformulier</h1>
        <h2>Auto</h2>

        <application-stepper current-step="5" :loading="!loaded">
            <v-form @submit.prevent="submit">
                <v-error-messages ref="errorMessages" :messages="this.errorMessages"></v-error-messages>

                <h3>Auto</h3>

                <v-switch class="pl-4" v-model="applicant.hasCar" label="Heeft u een auto?" inset></v-switch>

                <template v-if="applicant.hasCar">
                    <v-text-field :error="hasErrors('carLicensePlate')" :error-messages="handleErrors('carLicensePlate')" v-model="applicant.carLicensePlate" label="Kenteken"></v-text-field>

                    <v-textarea :error="hasErrors('carReason')" :error-messages="handleErrors('carReason')" v-model="applicant.carReason" label="Waarom heeft u een auto?"></v-textarea>

                    <v-float-field :error="hasErrors('carRoadTaxAmount')" :error-messages="handleErrors('carRoadTaxAmount')"
                        v-model="applicant.carRoadTaxAmount"
                        prefix="€"
                        label="Wegenbelasting per maand"
                    ></v-float-field>
                    <v-float-field :error="hasErrors('carInsuranceAmount')" :error-messages="handleErrors('carInsuranceAmount')"
                        v-model="applicant.carInsuranceAmount"
                        prefix="€"
                        label="Autoverzekering per maand"
                    ></v-float-field>
                    <v-float-field :error="hasErrors('carFuelAmount')" :error-messages="handleErrors('carFuelAmount')"
                        v-model="applicant.carFuelAmount"
                        prefix="€"
                        label="Tanken per maand"
                    ></v-float-field>
                    <v-float-field
                        v-model="carTotalAmount"
                        prefix="€"
                        label="Totaal kosten auto"
                        readonly
                    ></v-float-field>
                </template>

                <v-row>
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                        <v-btn @click="back" :loading="backBtnClicked" :disabled="submitting">Vorige</v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn color="primary" @click="submit" :loading="submitBtnClicked" :disabled="submitting"
                            >Volgende</v-btn
                        >
                    </v-col>
                </v-row>
            </v-form>
        </application-stepper>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ApplicationStepper from '../components/ApplicationStepper';
import VErrorMessages from '@/components/VErrorMessages';
import VFloatField from '@/components/VFloatField';

export default {
    name: 'step5-car',
    components: {
        ApplicationStepper,
        VErrorMessages,
        VFloatField,
    },
    data: () => ({
        errorDetails: {},
        loaded: false,
        backBtnClicked: false,
        submitBtnClicked: false,
        submitting: false,

        errorMessages: [],
        applicant: {
            hasCar: false,
            carLicensePlate: null,
            carReason: null,
            carRoadTaxAmount: null,
            carInsuranceAmount: null,
            carFuelAmount: null,
        },
    }),
    computed: {
        ...mapGetters({ vuex: 'step5' }),
        carTotalAmount() {
            let carTotalAmount = 0;
            if (parseInt(this.applicant.carRoadTaxAmount)) {
                carTotalAmount += parseInt(this.applicant.carRoadTaxAmount);
            }
            if (parseInt(this.applicant.carInsuranceAmount)) {
                carTotalAmount += parseInt(this.applicant.carInsuranceAmount);
            }
            if (parseInt(this.applicant.carFuelAmount)) {
                carTotalAmount += parseInt(this.applicant.carFuelAmount);
            }

            if (carTotalAmount < 1) {
                carTotalAmount = null;
            }

            return carTotalAmount;
        },
    },
    created: function() {
        const that = this;

        this.step5Load().then(function() {
            that.applicant.hasCar = that.vuex.applicant.hasCar;
            that.applicant.carLicensePlate = that.vuex.applicant.carLicensePlate;
            that.applicant.carReason = that.vuex.applicant.carReason;
            that.applicant.carRoadTaxAmount = that.vuex.applicant.carRoadTaxAmount;
            that.applicant.carInsuranceAmount = that.vuex.applicant.carInsuranceAmount;
            that.applicant.carFuelAmount = that.vuex.applicant.carFuelAmount;

            that.loaded = true;
        });
    },
    methods: {
        ...mapActions(['step5Load', 'step5Submit']),
        hasErrors(name) {
            return '' !== this.handleErrors(name);
        },
        handleErrors(name) {
            if (this.errorDetails[name] !== undefined) {
                let error = '';
                Object.entries(this.errorDetails[name]).forEach(entry => {
                    const [errorType, value] = entry;
                    error += " " + value;
                });
                return error;
            }
            return '';
        },
        getPayload() {
            return {
                applicant: {
                    hasCar: this.applicant.hasCar === true,
                    carLicensePlate: this.applicant.carLicensePlate,
                    carReason: this.applicant.carReason,
                    carRoadTaxAmount: this.applicant.carRoadTaxAmount,
                    carInsuranceAmount: this.applicant.carInsuranceAmount,
                    carFuelAmount: this.applicant.carFuelAmount,
                },
            };
        },
        back: function() {
            const that = this;
            this.backBtnClicked = true;
            this.submitting = true;
            this.errorMessages = [];

            this.step5Submit(this.getPayload()).finally(function() {
                that.$router.push({ name: 'step4_capital' });
                that.backBtnClicked = false;
                that.submitting = false;
            });
        },
        submit: function() {
            const that = this;
            this.submitBtnClicked = true;
            this.submitting = true;
            this.errorMessages = [];

            this.step5Submit(this.getPayload())
                .then(function() {
                    that.$router.push({ name: 'step6_income' });
                })
                .catch(function (error) {
                    const response = error.response;
                    if (response.data !== undefined && response.data.error !== undefined) {
                        that.errorDetails = response.data.error.messages;
                        that.errorMessages = ['Er ontbreken gegevens in deze stap'];
                    } else {
                        that.errorMessages = ['Onbekende fout!'];
                    }
                    that.$vuetify.goTo(that.$refs.errorMessages, {
                        duration: 300,
                        offset: 100,
                        easing: 'easeInOutCubic',
                    });
                })
                .finally(function() {
                    that.submitBtnClicked = false;
                    that.submitting = false;
                });
        },
    },
};
</script>
